import { render, staticRenderFns } from "./OrderPreparation.vue?vue&type=template&id=17b2c20e&scoped=true&"
import script from "./OrderPreparation.vue?vue&type=script&lang=ts&"
export * from "./OrderPreparation.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPreparation.vue?vue&type=style&index=0&id=17b2c20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2c20e",
  null
  
)

export default component.exports